import { Col, Select } from 'antd';
import dayjs from 'dayjs';
import React, { useMemo, useState } from 'react';

interface IProps {
  dateRange: { startAt: string; endAt: string } | undefined;
  setDateRange: (value: { startAt: string; endAt: string }) => void;
}

export const TimeRangeSelect: React.FC<IProps> = ({ dateRange, setDateRange }) => {
  const [startTime, setStartTime] = useState<string>(dayjs(dateRange?.startAt).format('HH:mm'));
  const [endTime, setEndTime] = useState<string>(dayjs(dateRange?.endAt).format('HH:mm'));

  const handleTimeChange = (value: string, type: 'start' | 'end') => {
    const time = value.split(':');
    let start = dayjs(dateRange?.startAt);
    let end = dayjs(dateRange?.endAt);

    if (type === 'start') {
      start = start.hour(Number(time[0])).minute(Number(time[1])).second(0);
      setStartTime(value);
      if (start.isAfter(end)) {
        const nextEndTime = timeSelectOptions.find((option) => option.value > value)?.value;
        if (nextEndTime) {
          const [hour, minute] = nextEndTime.split(':');
          end = end.hour(Number(hour)).minute(Number(minute)).second(0);
          setEndTime(nextEndTime);
        }
      }
    } else {
      end = end.hour(Number(time[0])).minute(Number(time[1])).second(0);
      setEndTime(value);
    }

    setDateRange({ startAt: start.toISOString(), endAt: end.toISOString() });
  };

  const index = useMemo(
    () => timeSelectOptions.findIndex((x) => x.value === startTime),
    [startTime]
  );

  const endTimes = useMemo(() => timeSelectOptions.slice(index + 1), [index]);

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Col className="time-range-select">
        <Select
          style={{ width: '100%', minWidth: '100px' }}
          options={timeSelectOptions}
          value={startTime}
          onChange={(e) => handleTimeChange(e, 'start')}
        />
      </Col>
      <Col style={{ textAlign: 'center' }}>to</Col>
      <Col className="time-range-select">
        <Select
          style={{ width: '100%', minWidth: '100px' }}
          options={endTimes}
          value={endTime}
          onChange={(e) => handleTimeChange(e, 'end')}
        />
      </Col>
    </div>
  );
};

interface IOption {
  value: string;
  label: string;
}

const timeSelectOptions: IOption[] = Array.from({ length: 24 }, (_, hour) =>
  Array.from({ length: 2 }, (_, index) => {
    const hourValue = hour;
    const minuteValue = index * 30;
    const formattedHour = hourValue.toString().padStart(2, '0');
    const formattedMinute = minuteValue.toString().padStart(2, '0');
    const time = `${formattedHour}:${formattedMinute}`;
    return { value: time, label: time };
  })
).flat();
